(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vac-product-siblings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vac-product-siblings')) {
    customElements.define('vac-product-siblings', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.track = this.querySelector('[data-vac-sibling-track]');
        this.controls = this.querySelector('[data-vac-sibling-controls]');
        if (!this.track || !this.controls) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.previous = this.querySelector('[data-vac-sibling-step="-1"]');
        this.next = this.querySelector('[data-vac-sibling-step="1"]');
        this.update = () => {
          const limit = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const offset = Math.abs(this.track.scrollLeft);
          this.controls.hidden = limit <= 2;
          this.previous.disabled = offset <= 2;
          this.next.disabled = offset >= limit - 2;
        };
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-vac-sibling-step]');
          if (!button || button.disabled) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const item = this.track.querySelector('li');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
          const count = Math.max(1, Math.floor(this.track.clientWidth / step));
          this.track.scrollBy({left: Number(button.dataset.vacSiblingStep) * step * count * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, { signal });
        this.track.addEventListener('scroll', this.update, { passive: true, signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        const current = this.track.querySelector('[aria-current="page"]');
        if (current) {
          const trackRect = this.track.getBoundingClientRect();
          const currentRect = current.getBoundingClientRect();
          if (currentRect.right > trackRect.right) this.track.scrollLeft += currentRect.right - trackRect.right + 2;
          else if (currentRect.left < trackRect.left) this.track.scrollLeft -= trackRect.left - currentRect.left + 2;
        }
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
